<app-searchbox-wrapper></app-searchbox-wrapper>
<div class='home-container' [class.fade-in-ani]="playFadeInAnimation">
  <ng-container>
    <div class="summary-intro-container">
      <activity-summary-intro-animation
        class="summary-intro-animation"
      >
      </activity-summary-intro-animation>
    </div>
  </ng-container>
  <ng-container *ngIf="isIntroAnimationComplete">
    <app-tab-selector [selectedTab]="'summary'"></app-tab-selector>
    <div class="activity-summary-container renaissance-style-scoped" aria-labelledby="skip-nav">
      <div class="activity-summary-header-container1">
        <h2 id="skip-nav" tabindex="-1">Activity Summary and Recommendations</h2>
        <p class="description">
          Here's how students are doing in your Renaissance programs, based on their work over the
          <span class="bolded">last two weeks</span> or the <span class="bolded">latest test.</span>
        </p>
        <a id="pendo-guide-learn-more" class="learn-more-text" href="#" (click)="$event.preventDefault()" role="button">Learn
          more.</a>
      </div>
      <div class="context-selector">
        <context-selector></context-selector>
      </div>
      <div class="summary-table-container">
        <!-- Loading spinner -->
        <div *ngIf="!didLoad || showSpinner">
          <mat-spinner diameter="60" mode="indeterminate" class="mat-spinner activity-summary-spinner"></mat-spinner>
        </div>
        <div *ngIf="didLoad && !hasData && !showSpinner">
          <app-no-data></app-no-data>
        </div>
        <div *ngIf="didLoad && hasData && !showSpinner" role="group" aria-label="Activity Summary Category">
          <div class="tab-container" role="tablist">
            <app-activity-summary-tab
              [id]="activitySummaryTabOptions.CategoryWholeClass"
              headerTitle="Whole Class"
              [numStudents]="wholeClassStudents.length"
              [showNumStudents]="false"
              [selectedTab]="selectedTab"
              (tabClicked)="selectTab($event)">
            </app-activity-summary-tab>
            <app-activity-summary-tab
              [id]="activitySummaryTabOptions.CategoryNeedAHelpingHand"
              headerTitle="Needs a Helping Hand"
              [numStudents]="needsAHelpingHandStudents.length"
              [showNumStudents]="true"
              color="#DA4646"
              [selectedTab]="selectedTab"
              (tabClicked)="selectTab($event)">
            </app-activity-summary-tab>
            <app-activity-summary-tab
              [id]="activitySummaryTabOptions.CategoryReadyForMore"
              headerTitle="Ready for a Challenge"
              [numStudents]="readyToBeChallengedStudents.length"
              [showNumStudents]="true"
              color="#00A929"
              [selectedTab]="selectedTab"
              (tabClicked)="selectTab($event)">
            </app-activity-summary-tab>
            <app-activity-summary-tab
              class="last-tab"
              [id]="activitySummaryTabOptions.CategoryTimeToPractice"
              headerTitle="Time to Practice"
              [numStudents]="timeToPracticeStudents.length"
              [showNumStudents]="true"
              color="#707070"
              [selectedTab]="selectedTab"
              (tabClicked)="selectTab($event)">
            </app-activity-summary-tab>
            <a id="pendo-guide-what-does-this-mean" class="what-does-this-mean" href="#" (click)="$event.preventDefault()" role="button">
              <span class="glyph glyph-info"></span>
              <span>What does this mean?</span>
            </a>
          </div>
          <div *ngIf="showTabSpinner">
            <mat-spinner diameter="60" mode="indeterminate" class="mat-spinner activity-summary-spinner"></mat-spinner>
          </div>
          <div *ngIf="!showTabSpinner">
            <div class="student-table-border">
              <time-to-practice-recommendation
                *ngIf="selectedTab==activitySummaryTabOptions.CategoryTimeToPractice"
                [classProducts]="classProducts"
              >
              </time-to-practice-recommendation>
              <student-table  [students]="studentsToDisplay" [category]="selectedTab" [classProducts]="classProducts" [showTakeAction]="showTakeAction()"></student-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-footer></app-footer>
    <div id="pendo-intro-animation-complete" class="pendo-only-element"
      *ngIf="showAnimationCompletePendoElement"></div>
  </ng-container>
</div>
